export default __webpack_public_path__ + "static/media/exe.1017f88f.svg";